import { render } from 'react-dom';
import Form720GraphSpain from './form720GraphSpain';

const rootElement = document.querySelector('#root');
if (rootElement) {
  render(
    <Form720GraphSpain/>,
    rootElement);
}
